module.exports = __webpack_public_path__ + "media/features/training-load-with-readiness-0387ee97.jpg";